import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faSquareSmall as fasSquareSmall,
	faLink as fasLink,
	faCheck as fasCheck,
	faCircleCheck as fasCircleCheck,
	faCircleExclamation as fasCircleExclamation,
	faCircleQuestion as fasCircleQuestion,
	faTriangleExclamation as fasTriangleExclamation,
	faHyphen as fasHyphen,
	faXmark as fasXmark,
	faGamepadModern as fasGamepadModern,
	faGift as fasGift,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import React from "react";
import type { ListContextType, ListItemProps } from "./List.types";

export const ListContext = React.createContext<ListContextType>({
	itemStyle: "tick",
});
export default class ListItem extends React.PureComponent<ListItemProps> {
	public static contextType = ListContext;
	public readonly context: React.ContextType<typeof ListContext>;

	private renderIcon(): ReactNode {
		const { itemStyle: mainItemStyle } = this.context;
		const { itemStyle = mainItemStyle } = this.props;
		let icon: IconDefinition;

		switch (itemStyle) {
			case "square":
				icon = fasSquareSmall;
				break;

			case "link":
				icon = fasLink;
				break;

			case "tick":
				icon = fasCheck;
				break;

			case "circle-tick":
				icon = fasCircleCheck;
				break;

			case "info-circle":
				icon = fasCircleExclamation;
				break;

			case "question-circle":
				icon = fasCircleQuestion;
				break;

			case "warning-triangle":
				icon = fasTriangleExclamation;
				break;

			case "dash":
				icon = fasHyphen;
				break;

			case "xmark":
				icon = fasXmark;
				break;

			case "gamepad-modern":
				icon = fasGamepadModern;
				break;

			case "gift":
				icon = fasGift;
				break;

			default:
				return null;
		}

		return <FontAwesomeIcon icon={icon} className="mr-2" />;
	}

	public render(): ReactNode {
		const { itemStyle: mainItemStyle } = this.context;
		const { itemStyle = mainItemStyle, children, className } = this.props;

		return (
			<li
				className={[
					className,
					(mainItemStyle === "number" || mainItemStyle === "circled-number") &&
						itemStyle !== "number" &&
						itemStyle !== "circled-number" &&
						"list-style-none",
				]
					.filter(Boolean)
					.join(" ")}
			>
				{this.renderIcon()}
				{children}
			</li>
		);
	}
}
